import { atom } from "recoil";

export const profilePrefillMetadataState = atom({
  key: "profilePrefillMetadata", // unique ID (with respect to other atoms/selectors)
  default: {
    profiles: [],
  },
});
